import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-standard-layout-container',
  imports: [],
  templateUrl: './standard-layout-container.component.html',
  styleUrl: './standard-layout-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardLayoutContainerComponent {}
